import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import React, { useCallback } from 'react';

import { useOrganization } from '../context/OrganizationContext';
import { ThemeSwitchProvider } from '../context/ThemeContext';
import useLocalStorage from '../hooks/useLocalStorage';
import { lightTheme, darkTheme } from '../styles/theme';
import { colorsToLoja } from './colors';

type Props = {
	children: React.ReactNode | React.ReactNode[];
};

export const DefaultLayout = ({ children }: Props) => {

	const [theme, setTheme] = useLocalStorage('theme', 'light');

	const toggleTheme = useCallback(() => {
		setTheme((t: 'dark' | 'light') => (t === 'light' ? 'dark' : 'light'));
	}, [setTheme]);

	return (
		<ThemeProvider
			theme={theme === 'light' ? lightTheme(colorsToLoja) : darkTheme(colorsToLoja)}
		>
			<CssBaseline />
			<ThemeSwitchProvider theme={theme} toggleTheme={toggleTheme}>
				{children}
			</ThemeSwitchProvider>
		</ThemeProvider>
	);
};
